import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InternalRepatriationsTransactionsDeleteDialog from './InternalRepatriationsTransactionsDeleteDialog';
import InternalRepatriationCreateFormDialog from '../../../../../reporting/internal-repatriation/containers/InternalRepatriationCreateFormDialog';
import RepatriationsTransactionsEdit from '../../edit/containers/RepatriationsTransactionsEdit';

class InternalRepatriationsTransactionsDelete extends Component {
  render() {
    return (
      <div>
        <InternalRepatriationsTransactionsDeleteDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

InternalRepatriationsTransactionsDelete.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default InternalRepatriationsTransactionsDelete;
